import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M20.424 5.576a.6.6 0 0 1 0 .848l-11 11a.6.6 0 0 1-.848 0l-5-5a.6.6 0 0 1 .848-.848L9 16.15 19.576 5.576a.6.6 0 0 1 .848 0Z"
      clip-rule="evenodd"
    />
  </svg>
`;
